import { ScheduleType } from "./type";

export const SCHEDULE: Record<string, ScheduleType> = {
  NOW: "now",
  LATER: "later",
};
